const getPuzzle = async (wordCount) => {
    const response = await fetch(`//puzzle.mead.io/puzzle?wordCount=${wordCount}`)
    
    if (response.status === 200) {
        const data = await response.json()
        return data.puzzle
    } else {
        throw new Error('Unable to get puzzle')
    }
}
export { getPuzzle as default }
// const getPuzzleOld = (wordCount) => {
//     return fetch(`http://puzzle.mead.io/puzzle?wordCount=${wordCount}`).then((response) => {
//          if (response.status === 200) {
//              return response.json()
//          } else {
//              throw new Error('Unable to fetch puzzle')
//          }
//      }).then((data) => {
//          return data.puzzle
//      })
//  }

// const getCurrentCountry = async () => {
//     const location = await getLocation()
//     const country = await countryCodeCall(location.country)
//     return country
// }


// const countryCodeCall = async (countryCode) => {
//     const response = await fetch('http://restcountries.eu/rest/v2/all')
   
//         if ( response.status === 200) {
//             const data = await response.json()
//            return data.find((country) => country.alpha2Code === countryCode)
//         } else {
//             throw new Error('Unable to fetch data')
//         }
//     }

// const getLocation = async () => {
//     const response = await fetch('http://ipinfo.io/json?token=aaa5380307ea6e')
    
//         if (response.status === 200) {
//             return response.json() 
//         } else {
//             throw new Error('Unable to fetch ip info')
//         }
    
// }

// const getWeather = async () => {
//    const response = await fetch('https://cors-anywhere.herokuapp.com/https://api.darksky.net/forecast/ec0f86b4eaf2cad9d5db0f40b29d5e24/37.8267,-122.4233')
 
//         if (response.status === 200) {
//            return response.json()
//         //    return weather
//         } else {
//             throw new Error('Unable to fetch weather')
//     }

// }

// const getWeather = () => {
//     return fetch('https://cors-anywhere.herokuapp.com/https://api.darksky.net/forecast/ec0f86b4eaf2cad9d5db0f40b29d5e24/37.8267,-122.4233')
//     .then((response) => {
//         if (response.status === 200) {
//             return response.json()
//         } else {
//             throw new Error('Unable to fetch weather')
//     }
// }).then((weather) => {
//     return weather
// })
// }
